import React, { useState } from 'react';

const SECTIONS = [
  {
    title: '第1条（サービスの概要）',
    body: `「えがおフォルダ」（以下「本サービス」）は、株式会社オーサム・ベース（以下「当社」）が提供する、顔認識技術を利用した写真自動振り分けサービスです。ユーザーは子供の顔写真を登録することで、大量の写真を子供ごとのフォルダへ自動で仕分けすることができます。\n\n本サービスは、保育園・幼稚園・認定こども園・学童保育・スポーツクラブ・写真館等、子供に関わる事業者（以下「事業者ユーザー」）が利用することを主に想定しています。`,
  },
  {
    title: '第2条（利用登録）',
    body: `1. 本サービスの利用を希望する方は、当社所定の方法により利用登録を申請するものとします。\n2. 当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録を拒否することがあります。\n　・虚偽の事項を届け出た場合\n　・本規約に違反したことがある者からの申請である場合\n　・その他、当社が利用登録を相当でないと判断した場合`,
  },
  {
    title: '第3条（利用料金・プラン）',
    body: `1. 本サービスには以下のプランがあります。\n　・フリープラン：累計100枚まで無料（月次リセットなし）\n　・スタンダードプラン：月額制、毎月1,000枚まで振り分け可能（毎月リセット）\n　・プレミアムプラン：月額制、毎月10,000枚まで振り分け可能（毎月リセット）\n2. 有料プランの料金は、当社が別途定める料金表に従います。\n3. 支払い済みの料金は、理由の如何を問わず返金しないものとします（プラン解約・退会等による期間途中の終了を含み、日割り返金は行いません）。ただし、法令により返金が義務付けられる場合はこの限りではありません。\n4. 料金は予告なく変更される場合があります。変更の際は30日前までにお知らせします。`,
  },
  {
    title: '第4条（事業者ユーザーの責務 — 保護者同意の取得）',
    body: `1. 子供（特に13歳未満）の顔写真等の個人情報を本サービスに登録するユーザーは、登録対象となる子供すべてについて、事前にその保護者（親権者）から以下の項目に関する同意を取得していることを表明・保証するものとします。\n　・本サービスへの顔写真および氏名の登録\n　・AWS Rekognition による顔特徴量の解析・保存（生体識別情報の取得）\n　・写真振り分けの結果として、当該子供が含まれる写真が事業者の管理下で取り扱われること\n\n2. 当社は、ユーザーが保護者から適切に同意を取得していることを前提に本サービスを提供します。保護者からの問い合わせ・苦情・同意の撤回等への対応は、事業者ユーザーの責任において行うものとします。\n\n3. 新たな子供を登録する際は、その都度、登録前に保護者の同意を取得するものとします。\n\n4. 保護者の同意取得方法は、書面・電子的記録・契約書への明記など、後日確認可能な方法によることを推奨します。\n\n5. 本条に違反したことにより生じた紛争・損害については、ユーザーがその責任を負うものとし、当社は一切の責任を負いません。`,
  },
  {
    title: '第5条（禁止事項）',
    body: `ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。\n1. 法令または公序良俗に違反する行為\n2. 犯罪行為に関連する行為\n3. 当社または第三者の著作権、商標権その他の知的財産権を侵害する行為\n4. 当社または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為\n5. 本サービスの運営を妨害するおそれのある行為\n6. 他のユーザーに関する個人情報等を収集または蓄積する行為\n7. 不正アクセスをし、またはこれを試みる行為\n8. 第三者に成りすます行為\n9. 本サービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為\n10. 登録した顔情報を本人または保護者の同意なく利用する行為\n11. 保護者の事前同意を取得していない子供の顔写真を登録する行為`,
  },
  {
    title: '第6条（サービスの提供の停止等）',
    body: `当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができます。\n1. 本サービスにかかるシステムの保守点検または更新を行う場合\n2. 地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合\n3. コンピュータまたは通信回線等が事故により停止した場合\n4. その他、当社が本サービスの提供が困難と判断した場合`,
  },
  {
    title: '第7条（免責事項）',
    body: `1. 当社は、本サービスの顔認識精度について、特定の精度を保証するものではありません。\n2. 当社の都合によりサービス内容を変更、または提供を中止した場合、いかなる損害も責任を負いません。\n3. 本サービスはAWS Rekognitionを利用しており、AWSのサービス障害による影響については当社は責任を負いません。\n4. Google Driveとの連携に関して、Googleのサービス変更や障害による影響については当社は責任を負いません。\n5. ユーザーの不適切な利用によって生じた損害について、当社は責任を負いません。`,
  },
  {
    title: '第8条（サービスの変更・廃止）',
    body: `当社は、ユーザーへの事前通知なしに、本サービスの内容を変更または廃止することができます。これによりユーザーに生じた損害について、当社は一切の責任を負いません。`,
  },
  {
    title: '第9条（退会・解約）',
    body: `1. ユーザーは、当社所定の退会手続きにより、本サービスから退会できます。\n2. 退会時、登録されたすべての顔情報および利用履歴は削除されます（30日間の猶予を経て完全削除）。即時完全削除を希望することもできます。\n3. 退会後のデータ復元はできません。\n4. 退会と同時に有料プランのサブスクリプションは即時キャンセルされ、課金期間途中であっても日割り返金は行いません。サービスを課金期間の終了日まで利用したい場合は、退会ではなく「料金管理」ページからプラン解約（期間末解約）を選択してください。\n5. 無料トライアル期間中の解約はいつでも可能で、料金は一切発生しません。`,
  },
  {
    title: '第10条（規約の変更）',
    body: `当社は必要と判断した場合には、ユーザーへ通知の上、本規約を変更することができます。変更後の規約は、当社サービス上に掲示した時点で効力を生じるものとします。変更後も本サービスを継続して利用した場合、変更後の規約に同意したものとみなします。`,
  },
  {
    title: '第11条（個人情報の取扱い）',
    body: `当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。`,
  },
  {
    title: '第12条（準拠法・管轄裁判所）',
    body: `本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。`,
  },
];

export default function TermsPage({ standalone = false }) {
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <div className={standalone ? '' : 'page'} style={standalone ? { padding: '40px 24px', maxWidth: 760, margin: '0 auto' } : {}}>
      {!standalone && (
        <div className="page-header animate-in">
          <h1 className="page-title">利用規約</h1>
          <p className="page-subtitle">えがおフォルダ サービス利用規約</p>
        </div>
      )}

      <div className={standalone ? '' : 'page-body animate-in-delay-1'} style={{ maxWidth: 720 }}>

        {standalone && (
          <div style={{ marginBottom: 32, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
            <h1 style={{ fontSize: 24, fontWeight: 800, margin: '0 0 4px' }}>利用規約</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>えがおフォルダ サービス利用規約</p>
          </div>
        )}

        {/* 前文 */}
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 14,
          padding: '18px 20px',
          marginBottom: 24,
          fontSize: 13,
          lineHeight: 1.8,
          color: 'var(--text-muted)',
        }}>
          本利用規約（以下「本規約」）は、株式会社オーサム・ベース（以下「当社」）が提供するサービス「えがおフォルダ」の利用条件を定めるものです。登録ユーザーの皆さまには、本規約に従って本サービスをご利用いただきます。
        </div>

        {/* 条文アコーディオン */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 32 }}>
          {SECTIONS.map((sec, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              overflow: 'hidden',
            }}>
              <button
                onClick={() => toggle(i)}
                style={{
                  width: '100%', textAlign: 'left', padding: '14px 16px',
                  background: 'none', border: 'none', cursor: 'pointer',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  fontSize: 13, fontWeight: 700, color: 'var(--text-primary)',
                }}
              >
                <span>{sec.title}</span>
                <span style={{ fontSize: 14, color: 'var(--text-muted)', flexShrink: 0, marginLeft: 8 }}>
                  {open === i ? '▲' : '▼'}
                </span>
              </button>
              {open === i && (
                <div style={{
                  padding: '0 16px 16px',
                  borderTop: '1px solid var(--border)',
                  paddingTop: 12,
                  fontSize: 13,
                  lineHeight: 2,
                  color: 'var(--text-muted)',
                  whiteSpace: 'pre-wrap',
                }}>
                  {sec.body}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 施行日 */}
        <div style={{
          textAlign: 'right',
          fontSize: 12,
          color: 'var(--text-muted)',
          marginBottom: 24,
        }}>
          制定日：2025年1月1日<br />
          最終改定：2026年5月1日
        </div>

        {/* お問い合わせ */}
        <div style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 14,
          padding: '16px 20px',
          textAlign: 'center',
          fontSize: 13,
        }}>
          <p style={{ margin: '0 0 4px', fontWeight: 600 }}>お問い合わせ</p>
          <p style={{ margin: 0, color: 'var(--text-muted)' }}>
            <a href="mailto:info@036base.com" style={{ color: 'var(--primary)' }}>info@036base.com</a>
          </p>
        </div>

      </div>
    </div>
  );
}
